import React from "react";
import { motion } from "framer-motion";

const distances = [
  { km: "21.7", to: "Arrowtown" },
  { km: "25.3", to: "Cromwell" },
  { km: "27.5", to: "Frankton" },
  { km: "34.6", to: "Queenstown" },
];

export default function Distances() {
  return (
    <section
      id="distances"
      data-testid="distances-section"
      className="relative py-28 md:py-36 border-t border-white/5 bg-[#030303]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-6 h-px bg-[#E2B464]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E2B464]">
                Distance · Production Radius
              </span>
            </div>
            <h2 className="font-display font-light text-4xl md:text-6xl leading-[0.95] tracking-tighter">
              Inside the{" "}
              <span className="italic text-[#E2B464]">40 km radius</span> every
              production already plans for.
            </h2>
          </div>
          <p className="md:col-span-6 md:col-start-7 self-end text-zinc-400 leading-relaxed">
            Victoria Flats sits within Gibbston Character Zoning perfectly
            positioned to draw on the full crew, vendor and accommodation network
            of Queenstown, Frankton, Arrowtown and Cromwell.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {distances.map((d, i) => (
            <motion.div
              key={d.to}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`distance-${d.to.toLowerCase()}`}
              className="bg-[#050505] p-8 md:p-10 group hover:bg-[#0c0c0c] transition-colors"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
                To {d.to}
              </p>
              <div className="flex items-baseline gap-2">
                <span className="font-display font-extralight text-5xl md:text-6xl text-white tracking-tighter group-hover:text-[#E2B464] transition-colors">
                  {d.km}
                </span>
                <span className="font-mono text-sm text-[#E2B464]">km</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
